import {toast} from 'react-toastify';
import { api } from '@/api';
import { orderApiReq } from '@/api/interfaces/requests';
import { orderApiRes } from '@/api/interfaces/responses';
import {NAME_STATUS_API_ORDER} from '../../../consts';

export const handleClickLoadOrders = async (params: orderApiReq.ILoadOrderReq):Promise<orderApiRes.ILoadOrderRes> => {

  if (!params.date_from ) {
    toast.error('Необходимо выбрать дату!');
    throw new Error();
  } else {
    const responsePromise = api.order.loadOrders({
     ...params
    })
    toast.promise(
      responsePromise,
      {
        pending: NAME_STATUS_API_ORDER.LOAD_ORDERS.PENDING,
        error: {
          render(res: Record<string, any>) {
            const {status} = res.data.response;
            if (status === 500 || status === 501 || status === 502 || status === 503) {
              toast.error(NAME_STATUS_API_ORDER.LOAD_ORDERS.ERROR_500 + status)
            }
            return NAME_STATUS_API_ORDER.LOAD_ORDERS.ERROR
          }
        }
      })
    const response = await responsePromise;
    return response;
  }

}


export const genderOptions = [
  {
    label: 'Муж',
    value: 2
  },
  {
    label: 'Жен',
    value: 1
  }
];
